import { jsx as s } from "react/jsx-runtime";
import t, { css as o } from "styled-components";
const c = t.path`
  transition: ${(n) => n.$transition};
`, l = t.polygon``, r = ({ text: n }) => /* @__PURE__ */ s("title", { children: n }), a = t.mask``, $ = t.g``, g = t.ellipse``, m = t.circle``, p = t.line``, h = t.rect``, y = t.svg`
  ${(n) => `
  ${n.$cssHelper}
  ${n.$transition ? o`transition: ${n.$transition}` : ""}
  `}
`;
export {
  m as Circle,
  g as Elipse,
  $ as GElement,
  p as Line,
  a as Mask,
  c as Path,
  l as Polygon,
  h as Rectangle,
  y as Svg,
  r as Title
};
